import { first } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { ApiService } from './api';
import { Router, Event, NavigationEnd } from '@angular/router';
import { UserService } from './user.service';
import { TenantService } from './tenant.service';

@Injectable({ providedIn: 'root' })
export class EventService {
    private path: string = '/ws/item';
    private eventWriteUrl: string;
    private tenant: any;
    private previousUrl: string;
    public viewSessionId = Math.random();

    currentRoute = () => {
        let route = this.router.routerState.snapshot.root;
        while(route.firstChild){
            route = route.firstChild;
        }
        return route;
    };

    formatUser = (user, desiredPrefix?) => {
        const { emailAddress, firstName, id, lastName, status} = user;
        return this.prefixKeys({ emailAddress, firstName, id, lastName, status}, `${desiredPrefix || 'user'}_`);
    };

    pathForRoute = (route) => route && route.routeConfig && route.routeConfig.path ? route.routeConfig.path : '';

    addTenantAndUserData = eventData => {

        const currentRoute = this.currentRoute();
        debugger;

        return Object.assign({},
            {
                tenantId: this.tenant.id,
                tenantName: this.tenant.name,
            },
            {
                url_current: window.location.href,
                url_state: this.pathForRoute(currentRoute)
            },
            this.userService.getCurrentUser() ? this.formatUser(this.userService.getCurrentUser()) : { user_id: this.currentRoute().queryParams.userId },
            eventData
        );
    };

    constructor(private api: ApiService,
                private userService: UserService,
                tenantService: TenantService,
                private router: Router){
        tenantService.getUnauthTenantInfo().pipe(first())
        .subscribe(tenant => {
            this.tenant = tenant;
            if(this.tenant.settings && this.tenant.settings.eventWriteUrl) {
                this.eventWriteUrl = this.tenant.settings.eventWriteUrl;
            }
            this.router.events.subscribe((event: Event) => {
                if(event instanceof NavigationEnd){
                    this.postEvent('url_changed', { url_from_state: this.previousUrl });
                    this.previousUrl = event.urlAfterRedirects;
                }
            });
        });
    }

    postEvent = (eventName, eventData?) => {
        if(this.tenant.settings.eventWriteUrl) {
            const extendedEvent = this.addTenantAndUserData(eventData);
            this.api.post(this.tenant.settings.eventWriteUrl, {
                userId: extendedEvent.user_emailAddress || 'UNKNOWN', //UNKNOWN if user is logged out and we don't know who it is
                event: eventName,
                data: extendedEvent
            }, { responseType: 'text' }).pipe(first())
            .subscribe();
        }
    };

    postStreamItemEvent = (eventName, eventData, item, source) =>
        this.postEvent(eventName, this.buildItemEvent(eventData || {}, item, source, this.viewSessionId));

    buildItemEvent = (base, item, stream, uuid) =>
        Object.assign({}, base, this.formatItem(item), this.formatStream(stream), { viewItemSession: uuid });

    prefixKeys = (item, prefix) =>
        Object.keys(item).reduce((newItem, key) => {newItem[prefix + key] = item[key]; return newItem;}, {});

    formatItem = (item) => {
        const {cleanDescription, createdDate, id, link, publishedDate, streamId, tags, title, userTags} =
            Object.assign({}, item, {
                publishedDate: new Date(item.publishedDate).toISOString(),
                createdDate: item.created ? new Date(item.created).toISOString() : undefined,
                tags: item.tagText
            });
        return this.prefixKeys({cleanDescription, createdDate, id, link, publishedDate, streamId, tags, title, userTags}, 'item_');
    };

    formatStream = stream => {
        const { description, emailPostingEnabled, id,  followersCount, itemsCount, ownerId, rssEnabled, title, type } = stream;
        return this.prefixKeys({ description, emailPostingEnabled, id,  followersCount, itemsCount, ownerId, rssEnabled, title, type }, 'stream_');
    };
}
